import React, { PropsWithChildren } from 'react';
import Box from '@mui/material/Box';
import { i18n_my_account } from '@yi/i18n/phrases/i18n_my_account';
import { i18n_please_visit_the_account_page_to_check_payment_method } from '@yi/i18n/phrases/i18n_please_visit_the_account_page_to_check_payment_method';
import { i18n_your_membership_has_expired } from '@yi/i18n/phrases/i18n_your_membership_has_expired';

import { ButtonLocalizedLink } from '../../../buttons';
import { useLocale } from '../../../LocaleProvider';

export const InvalidMembership: React.FC<PropsWithChildren> = () => {
  const { locale } = useLocale();
  return (
    <Box p={3} textAlign="center">
      <h3>{i18n_your_membership_has_expired(locale)}</h3>
      <Box mb={3}>
        <p>{i18n_please_visit_the_account_page_to_check_payment_method(locale)}</p>
      </Box>
      <Box m={0}>
        <Box mb={3}>
          <ButtonLocalizedLink to="/account/membership">
            {i18n_my_account(locale)}
          </ButtonLocalizedLink>
        </Box>
      </Box>
    </Box>
  );
};
